import { createContext, useCallback, useContext, useMemo, useState } from "react";

const MobileNavigationContext = createContext(null);

export function MobileNavigationProvider({ children }) {
  const [activeSectionByRole, setActiveSectionByRole] = useState({});

  const setActiveSection = useCallback((role, section) => {
    setActiveSectionByRole((current) => {
      if (current[role] === section) return current;

      return {
        ...current,
        [role]: section
      };
    });
  }, []);

  const value = useMemo(() => ({
    activeSectionByRole,
    setActiveSection
  }), [activeSectionByRole, setActiveSection]);

  return (
    <MobileNavigationContext.Provider value={value}>
      {children}
    </MobileNavigationContext.Provider>
  );
}

export function useMobileNavigation() {
  const context = useContext(MobileNavigationContext);

  if (!context) {
    throw new Error("useMobileNavigation must be used within MobileNavigationProvider");
  }

  return context;
}
